import { render, staticRenderFns } from "./QueryClaimInfo.vue?vue&type=template&id=6cb54833&"
import script from "./QueryClaimInfo.vue?vue&type=script&lang=js&"
export * from "./QueryClaimInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports